// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.3_@rspack+core@1.7.6_webpack@5.99.9/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.3_@rspack+core@1.7.6_webpack@5.99.9/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ellipsis {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  /* Ensure bullet points remain visible even when overflow is hidden */
  li& {
    list-style-position: inside;
  }
}

.multiline-ellipsis {
  --ellipsis-lines: 3;

  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: var(--ellipsis-lines);
  overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/ui/ellipsis/ellipsis.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;;EAEnB,qEAAqE;EACrE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,mBAAmB;;EAEnB,4BAA4B;EAC5B,oBAAoB;EACpB,yCAAyC;EACzC,gBAAgB;AAClB","sourcesContent":[".ellipsis {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  /* Ensure bullet points remain visible even when overflow is hidden */\n  li& {\n    list-style-position: inside;\n  }\n}\n\n.multiline-ellipsis {\n  --ellipsis-lines: 3;\n\n  -webkit-box-orient: vertical;\n  display: -webkit-box;\n  -webkit-line-clamp: var(--ellipsis-lines);\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
var ___CSS_LOADER_STYLE_SHEET___ = new CSSStyleSheet();
___CSS_LOADER_STYLE_SHEET___.replaceSync(___CSS_LOADER_EXPORT___.toString());
export default ___CSS_LOADER_STYLE_SHEET___;
